var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillLevelColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0625 29.0625H21.3125V3.875H29.0625V29.0625ZM19.375 29.0625H11.625V11.625H19.375V29.0625ZM9.6875 29.0625H1.9375V17.4375H9.6875V29.0625Z",
    fill: "#84E1CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillLevelColor);
export default __webpack_public_path__ + "static/media/skill-level-color.20591cb4f50f4ebcb38d827a883ad397.svg";
export { ForwardRef as ReactComponent };